import PRODUCT from '@/web/store/types/product'

function productAdapter(product) {
  return {
    node: Object.assign({}, {
      id: product.id.toString(),
      title: { name: product.title },
      size: { name: product.size },
      photo: {
        image_public_id: product.photo.image_public_id
      },
      price: {
        original: product.price.original,
        current: product.price.current
      },
      likes_count: product.likes_count || 0,
      user_like: product.is_product_liked_by_user || false,
      shipping: { free: product.free_shipping },
      used: product.used,
      path: product.path_url,
      brand: { displayable_name: product.brand },
      store: {
        displayable: {
          avatar: {
            image_public_id: product.seller.displayable.avatar.image_public_id
          },
          name: product.seller.displayable.name
        },
        path: product.seller.path
      }
    })
  }
}

export default {
  [PRODUCT.MUTATIONS.SET_PRODUCT]: (state, payload) => {
    state.id = payload.id
    state.slug = payload.slug
    state.sellerId = payload.seller_id
    state.ownerId = payload.owner_id
    state.planId = payload.plan_id
    state.title = payload.title
    state.description = payload.description
    state.used = payload.used
    state.brand = payload.brand
    state.size = payload.size
    state.categories = payload.categories
    state.photos = payload.photos
    state.comments = payload.comments
    state.relatedProductsQuery = payload.related_products_query
    state.variations = payload.variations
    state.singlePiece = payload.single_piece
    state.seoCategory = payload.seo_category
  },
  [PRODUCT.MUTATIONS.SET_OFFER]: (state, payload) => {
    state.offer = payload
  },
  [PRODUCT.MUTATIONS.SET_PURCHASE]: (state, payload) => {
    state.purchase = payload
  },
  [PRODUCT.MUTATIONS.SET_REGULAR_PRICE]: (state, payload) => {
    state.regularPrice = payload
  },
  [PRODUCT.MUTATIONS.SET_TIMER_PRICE]: (state, payload) => {
    state.timerPrice = payload
  },
  [PRODUCT.MUTATIONS.SET_STORE_PRODUCTS_PATH]: (state, payload) => {
    state.storeProductsPath = payload
  },
  [PRODUCT.MUTATIONS.SET_RELATED_PRODUCTS_PATH]: (state, payload) => {
    state.relatedProductsPath = payload
  },
  [PRODUCT.MUTATIONS.SET_NAVIGATION_HISTORY_PATH]: (state, payload) => {
    state.navigationHistoryPath = payload
  },
  [PRODUCT.MUTATIONS.SET_OWNER_ID]: (state, payload) => {
    state.ownerId = payload
  },
  [PRODUCT.MUTATIONS.SET_FALLBACK_PRICING]: (state, payload) => {
    state.fallbackPricing = payload
  },
  [PRODUCT.MUTATIONS.SET_STORE_ID]: (state, payload) => {
    state.storeId = payload
  },
  [PRODUCT.MUTATIONS.SET_RELATED_PRODUCTS]: (state, payload) => {
    const products = payload.products.filter(product => product.node.id.toString() !== state.id.toString()).slice(0, 5)

    state.relatedProducts.products = products
    state.relatedProducts.isFetching = payload.isFetching
  },
  [PRODUCT.MUTATIONS.SET_IS_FLASH_SALE]: (state, payload) => {
    state.isFlashSale = payload
  },
  [PRODUCT.MUTATIONS.SET_MORE_FROM_STORE]: (state, payload) => {
    const products = payload.products.filter(product => product.node.id.toString() !== state.id.toString()).slice(0, 5)

    state.moreFromStore.products = products
    state.moreFromStore.isFetching = payload.isFetching
  },
  [PRODUCT.MUTATIONS.SET_CURRENT_USER_ID]: (state, payload) => {
    state.currentUserId = payload
  },
  [PRODUCT.MUTATIONS.SET_NAVIGATION_HISTORY]: (state, payload) => {
    const products = payload.products.map(product => productAdapter(product))

    state.navigationHistory.products = products
    state.navigationHistory.isFetching = payload.isFetching
  },
  [PRODUCT.MUTATIONS.SET_IS_FETCHING_PRICE]: (state, payload) => {
    state.isFetchingPrice = payload
  },
  [PRODUCT.MUTATIONS.SET_IS_READY]: (state, payload) => {
    state.isReady = payload
  },
  [PRODUCT.MUTATIONS.SET_VARIATIONS]: (state, payload) => {
    state.variations = payload
  },
  [PRODUCT.MUTATIONS.SET_HAS_FILLED_META_TAGS]: (state, payload) => {
    state.hasFilledMetaTags = payload
  },
  [PRODUCT.MUTATIONS.SET_SHIPPING]: (state, payload) => {
    state.shipping = payload
  },
  [PRODUCT.MUTATIONS.SET_IS_SHIPPING_PRICE_ENABLE]: (state, payload) => {
    state.isShippingPriceEnable = payload
  },
  [PRODUCT.MUTATIONS.SET_SERVICE_TAX]: (state, payload) => {
    state.serviceTax = payload
  },
  [PRODUCT.MUTATIONS.SET_COUPON]: (state, payload) => {
    state.coupon = payload
  },
  [PRODUCT.MUTATIONS.SET_HAS_COPIED_COUPON_CODE]: (state, payload) => {
    state.hasCopiedCouponCode = payload
  },
  [PRODUCT.MUTATIONS.SET_SIMILAR_PRODUCT_INFO]: (state, payload) => {
    state.similarProductInfo = payload
  },
  [PRODUCT.MUTATIONS.SET_PRODUCT_ACTIONS]: (state, payload) => {
    state.actions = payload
  },
  [PRODUCT.MUTATIONS.SET_PRODUCT_BANNER]: (state, payload) => {
    state.banner = payload
  },
  [PRODUCT.MUTATIONS.SET_IS_FETCHING_ACTIONS]: (state, payload) => {
    state.isFetchingActions = payload
  },
  [PRODUCT.MUTATIONS.SET_SHOW_BUNDLE_SUGGESTION_MODAL]: (state, payload) => {
    state.isProductSuggestionModalOpen = payload
  },
  [PRODUCT.MUTATIONS.SET_RELATED_PRODUCT_SEARCH_ID]: (state, payload) => {
    state.relatedProductSearchId = payload
  },
  [PRODUCT.MUTATIONS.SET_MORE_FROM_STORE_SEARCH_ID]: (state, payload) => {
    state.setMoreFromStoreSearchId = payload
  }
}
